module.exports = __webpack_public_path__ + "static/media/country_kr.114474ce.webp";